import React from "react";
import { Button } from "carbon-components-react";
import { useNavigate } from "react-router-dom";
import { Add16 } from "@carbon/icons-react";

const AddEntityButton = ({ url, label, icon, kind }) => {

  const navigate = useNavigate();

  return (
    <div className="mb-2 form-buttons">
      <p></p>
      <Button
        kind={kind}
        onClick={() => navigate(url)}
        renderIcon={icon}
      >
        {label}
      </Button>
    </div>
  );
};

AddEntityButton.defaultProps = {
  label: "Add New",
  icon: Add16,
  kind: "ghost"
};

export default AddEntityButton;
